/* eslint-disable @typescript-eslint/lines-between-class-members */
export default class ContentTypes {
    static readonly ApplicationJson = 'application/json';
    static readonly ImageJpeg = 'image/jpeg';
}
